import { useContext } from "react";
import { LoadingContext } from "./LoadingContext";

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
};

/**
 * Hook for inline loading on buttons
 * @param elementId - Unique ID for the element (e.g., button ID)
 */
export const useInlineLoading = (elementId: string) => {
  const { inlineLoadingElement, setLoading } = useLoading();
  const isLoading = inlineLoadingElement === elementId;

  const showLoading = () => {
    setLoading(true, "inline", elementId);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  return {
    isLoading,
    showLoading,
    hideLoading,
  };
};
